export default "__VITE_ASSET__pdijCQec__"